// Furnio redesign — shared interaction layer (mobile nav, lightbox, teaser estimate widget).
(function () {
  "use strict";

  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---------------- Mobile nav ---------------- */
  function initMobileNav() {
    var burger = document.querySelector("[data-fx-burger]");
    var nav = document.querySelector("[data-fx-mobile-nav]");
    if (!burger || !nav) return;
    burger.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      document.body.classList.toggle("fx-nav-open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        nav.classList.remove("is-open");
        document.body.classList.remove("fx-nav-open");
      });
    });
  }

  /* ---------------- Lightbox ---------------- */
  // Trigger: <button data-fx-open="panel-key">
  // A page can have more than one overlay (e.g. categories + projects lightboxes
  // both on Home) - each <div data-fx-lightbox> owns its own set of panels.
  function initLightbox() {
    var overlays = document.querySelectorAll("[data-fx-lightbox]");
    if (!overlays.length) return;

    function closeAll() {
      overlays.forEach(function (o) { o.classList.remove("is-open"); });
      document.body.classList.remove("fx-nav-open");
    }
    function open(key) {
      var opened = false;
      overlays.forEach(function (overlay) {
        var panels = overlay.querySelectorAll("[data-fx-panel]");
        var match = false;
        panels.forEach(function (p) {
          var isMatch = p.getAttribute("data-fx-panel") === key;
          p.hidden = !isMatch;
          if (isMatch) match = true;
        });
        overlay.classList.toggle("is-open", match);
        if (match) opened = true;
      });
      if (opened) document.body.classList.add("fx-nav-open");
    }

    document.querySelectorAll("[data-fx-open]").forEach(function (trigger) {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        open(trigger.getAttribute("data-fx-open"));
      });
    });
    overlays.forEach(function (overlay) {
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) closeAll();
      });
      overlay.querySelectorAll("[data-fx-close]").forEach(function (btn) {
        btn.addEventListener("click", closeAll);
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAll();
    });
  }

  /* ---------------- Home teaser estimate widget ---------------- */
  // Priced with the real furnio-quote calculation engine (window.FurnioEngine),
  // modelling a "run" as repeated 600mm cabinet modules at category-typical H/D.
  var CATEGORY_DEFAULTS = {
    kitchen: { label: "Kitchen", height: 850, depth: 580 },
    wardrobe: { label: "Wardrobe", height: 2100, depth: 600 },
    tv: { label: "TV unit", height: 450, depth: 400 },
  };
  var FINISH_TO_SHUTTER = {
    Laminate: "Standard",
    Technomatt: "Technomatt",
    PU: "PU",
    Acrylic: "Acrylic",
    Veneer: "Veneer",
    Fenix: "Fenix",
    Glass: "Glass",
  };
  var MODULE_WIDTH_MM = 600;

  function fmtRange(v) {
    if (v >= 100000) return "₹" + (v / 100000).toFixed(1) + " L";
    return "₹" + Math.round(v / 1000) + "k";
  }

  function initEstimateWidget() {
    var widget = document.querySelector("[data-fx-estimate-widget]");
    if (!widget || !window.FurnioEngine) return;
    var engine = window.FurnioEngine;

    var state = { cat: widget.getAttribute("data-default-cat") || "wardrobe", width: 10, finish: "Laminate" };

    var catButtons = widget.querySelectorAll("[data-fx-cat]");
    var finishButtons = widget.querySelectorAll("[data-fx-finish]");
    var slider = widget.querySelector("[data-fx-width-slider]");
    var widthOut = widget.querySelector("[data-fx-width-out]");
    var sftOut = widget.querySelector("[data-fx-sft-out]");
    var rangeOut = widget.querySelector("[data-fx-range-out]");

    function render() {
      catButtons.forEach(function (b) { b.classList.toggle("is-active", b.getAttribute("data-fx-cat") === state.cat); });
      finishButtons.forEach(function (b) { b.classList.toggle("is-active", b.getAttribute("data-fx-finish") === state.finish); });
      if (widthOut) widthOut.textContent = state.width;

      var def = CATEGORY_DEFAULTS[state.cat] || CATEGORY_DEFAULTS.wardrobe;
      var runMm = state.width * 304.8;
      var moduleCount = Math.max(1, Math.round(runMm / MODULE_WIDTH_MM));
      var shutter = FINISH_TO_SHUTTER[state.finish] || "Standard";
      var item = { type: "cabinet", width: MODULE_WIDTH_MM, height: def.height, depth: def.depth, qty: moduleCount, shutter: shutter };
      var res = engine.calculateItem(item, engine.DEFAULT_RATES);

      if (sftOut) sftOut.textContent = Math.round(res.sft);
      if (rangeOut) rangeOut.textContent = fmtRange(res.price * 0.92) + " – " + fmtRange(res.price * 1.1);
    }

    catButtons.forEach(function (b) {
      b.addEventListener("click", function () { state.cat = b.getAttribute("data-fx-cat"); render(); });
    });
    finishButtons.forEach(function (b) {
      b.addEventListener("click", function () { state.finish = b.getAttribute("data-fx-finish"); render(); });
    });
    if (slider) {
      slider.addEventListener("input", function () { state.width = Number(slider.value); render(); });
    }
    render();
  }

  onReady(function () {
    initMobileNav();
    initLightbox();
    initEstimateWidget();
  });
})();
